import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
function Mobile_program() {
  const canonicalUrl = 'https://www.internselite.net/Training-Programs'
  return (
    <div>
      <Helmet>
        <title>
          Training Programs | InternsElite: Explore Our Courses and Internships
        </title>
        <meta
          name="description"
          content="Explore InternsElite’s diverse training programs, including online courses and internships. Our programs cover various fields such as AI, ML, Web Development, and more. Gain hands-on experience, earn certifications, and advance your career with our expert-led training."
        />
        <meta
          name="keywords"
          content="training programs, online courses, internships, professional courses, certification, career advancement"
        />
        <meta
          property="og:title"
          content="Training Programs | InternsElite: Explore Our Courses and Internships"
        />
        <meta
          property="og:description"
          content="Explore InternsElite’s diverse training programs, including online courses and internships. Our programs cover various fields such as AI, ML, Web Development, and more. Gain hands-on experience, earn certifications, and advance your career with our expert-led training."
        />
        <meta
          property="og:url"
          content="https://internselite.net/Training-Programs"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Training Programs | InternsElite: Explore Our Courses and Internships"
        />
        <meta
          name="twitter:description"
          content="Explore InternsElite’s diverse training programs, including online courses and internships. Our programs cover various fields such as AI, ML, Web Development, and more. Gain hands-on experience, earn certifications, and advance your career with our expert-led training."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {/* ----------------------------Mobile View--------------------------- */}
      <div className="container pt-5 mt-5 program_mobile_text d-md-block d-xl-none">
        <h1 className="display-5 text-center pt-5">Our Program</h1>
        <div className="my-4">
          <div className="text-center">
            <h5>Traineeship Program</h5>
            <p>
              Immerse in real-world challenges, gaining practical insights and
              honing your skills for a dynamic career journey.
            </p>
            <div>
              <Link to="/Traineeship-Program">
                <button className="shadow-sm  px-5 pt-1 pb-2 Navbar_button">
                  View More
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="border-top pt-4 pb-5">
          <div className="mobile_Program_link_text text-center">
            <h5>Advance Program</h5>
            <p>
              Unleash your potential through our comprehensive programs,
              designed to propel your expertise to new heights{' '}
            </p>
            <div>
              <Link to="/Advance-Program">
                <button className="shadow-sm px-5 pt-1 pb-2 Navbar_button">
                  View More
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="border-top pt-4 pb-5">
          <div className="text-center">
            <h5>Combo Program</h5>
            <div className="mt-4">
              <Link to="/Combo-Program">
                <button className="shadow-sm px-5 pt-1 pb-2 Navbar_button">
                  View More
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Mobile_program
